export default [
  {
    name: 'approvalSend',
    path: '/approval/Send',
    component: resolve => require(['Components/approval/approvalSend.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'approvalDetail',
    path: '/approval/Detail',
    component: resolve => require(['Views/Home/approvalList/Detail.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  }
]
